import { Box, Chip, Divider, Grid, IconButton, Tooltip, Typography } from '@mui/material'
import React, { useEffect } from 'react'
import { useGetSupplierDueDiligenceQuery, usePostSupplierMutation, useSubmitSupplierMutation } from '../../../store/api/supplierEvaluationApi';
import { useDispatch, useSelector } from 'react-redux';
import { useState } from 'react';
import SupText from './components/SupText';
import SupRadio from './components/SupRadio';
import SupAttachment from './components/SupAttachment';
import SupDataGrid from './components/SupDataGrid';
import SupSelect from './components/SupSelect';
import SupDate from './components/SupDate';
import SupTextArea from './components/SupTextArea';
import { showErrorToast, showSuccessToast, showWarningToast } from '../../../constToast/constToast';
import SaveDialog from '../../../components/Dialog/SaveDialog';
import { validateAttachmentsDeep } from '../../../components/Dialog/attachmentValidation';
import { nextStep, offNextButton } from '../../../store/slice/buttonSlice';
import SupTotalScore from './components/SupTotalScore';
import SupLoading from '../../../components/Loading/SupLoading';
import { updateSupNextButtonLoading } from '../../../store/slice/otherSlice';
import SubmitDialog from '../../../components/Dialog/SubmitDialog';
import { hideSubmitDialog } from '../../../store/slice/dialogSlice';
import { useNavigate } from 'react-router-dom';
import { Info } from '@mui/icons-material';

export default function DueDiligenceSup({ companyData, ndaData, cobcData, bankAccount, tableData, setTableData, vendorId, reviseSup }) {

  const { data, isLoading, refetch } = useGetSupplierDueDiligenceQuery(vendorId);
  const langCode = localStorage.getItem('lang')


  // useEffect(() => {
  //   if (langCode) {
  //     setTimeout(() => {
  //       refetch();
  //     }, 4000)
  //   }
  // }, [langCode, refetch]);

  const [isFirst, setIsFirst] = useState(true)

  useEffect(() => {
    if (tableData?.length > 0) {
      setTableData(tableData)
    }
    else if (!isLoading && data?.data?.length > 0) {
      setTableData(data?.data)
    } else {
      setTableData([])
    }

  }, [data, tableData, setTableData, isLoading])


  const arrElement = (value, pointKey, condition) => {
    return { value, pointKey, condition }
  }

  const arr = [
    arrElement('textboxValue', 'textBoxPoint', 'hasTextBox'),
    arrElement('textareaValue', 'textAreaPoint', 'hasTexArea'),
    arrElement('radioboxValue', 'radioBoxPoint', 'hasRadioBox'),
    arrElement('attachments', 'attachmentPoint', 'hasAttachment'),
    arrElement('bankListValue', 'bankListPoint', 'hasBankList'),
    arrElement('checkboxValue', 'checkBoxPoint', 'hasCheckBox'),
    arrElement('gridDatas', 'dataGridPoint', 'hasDataGrid'),
    arrElement('dateTimeValue', 'dateTimePoint', 'hasDateTime'),
    arrElement('decimalValue', 'decimalPoint', 'hasDecimal'),
    arrElement('intValue', 'intPoint', 'hasInt'),
  ]


  const calculateScoring = (child, key, value) => {
    const strings = ['hasTextBox', 'hasTexArea', 'hasBankList', 'hasDateTime', 'hasDecimal', 'hasInt', 'hasRadioBox', 'hasCheckBox']
    const arrs = ['hasAttachment', 'hasDataGrid']


    let scoring = 0
    let lineCount = 0
    let backCount = 0

    arr.forEach(item => {
      backCount = backCount + child[item.pointKey]
    })


    strings.forEach(item => {
      const element = arr.find(x => x.condition === item)
      if ((key === element.value ? value : child[element.value]) && child?.[item]) {
        lineCount = lineCount + child?.[element.pointKey]
      }
    })
    arrs.forEach(item => {
      const element = arr.find(x => x.condition === item)
      if (child?.[item] && (key === element.value ? value?.filter(item => item?.type != 2).length : child[element.value]?.filter(item => item?.type != 2)?.length)) {
        lineCount = lineCount + child?.[element.pointKey]
      }
    })

    scoring = ((lineCount) / backCount) * 100
    return scoring
  }

  const handleChangeData = (value, key, index, parentIndex) => {
    if (!tableData.length) {
      return
    }

    let newData = [...tableData || []]
    let childs = [...newData?.[parentIndex]?.childs || []]
    const child = childs?.[index]

    const scoring = calculateScoring(child, key, value)


    childs[index] = {
      ...childs?.[index],
      [key]: value,
      scoring,
      outcome: (child.weight * scoring) / 100
    }
    newData[parentIndex] = {
      ...newData[parentIndex],
      childs
    }
    setTableData(newData)

    // if (key === 'bankListValue') {
    //   const findBank = bankAccount.find(x => x.accountNumber === value)
    //   handleChangeData(findBank.accountNumber, 'textboxValue', 0, 0)
    // }
  }

  const totalScore = tableData?.reduce((total, item) => {
    const childOutcome = item?.childs?.reduce((subtotal, child) => subtotal + child.outcome, 0)
    return total + childOutcome
  }, 0)


  useEffect(() => {
    if (isFirst && Object.keys(companyData).length && tableData?.length) {
      setTableData(prevTableData => {
        const updatedDueDiligence = prevTableData.map(item => {
          return {
            ...item,
            childs: item.childs.map(child => {
              if (child.designId === 4) {
                const scoring = calculateScoring(child, 'textboxValue', companyData?.companyName)
                return {
                  ...child,
                  textboxValue: companyData?.companyName,
                  scoring,
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 5) {
                const scoring = calculateScoring(child, 'textboxValue', companyData?.webSite)
                return {
                  ...child,
                  textboxValue: companyData?.webSite,
                  scoring: calculateScoring(child, 'textboxValue', companyData?.webSite),
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 6) {
                const scoring = calculateScoring(child, 'textboxValue', companyData?.companyName)
                return {
                  ...child,
                  textboxValue: companyData?.companyName,
                  dateTimeValue: companyData?.registrationDate,
                  scoring: scoring,
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 34) {
                const scoring = calculateScoring(child, 'textboxValue', companyData?.companyAdress)
                return {
                  ...child,
                  textboxValue: companyData?.companyAdress,
                  scoring: calculateScoring(child, 'textboxValue', companyData?.companyAdress),
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 7) {
                const scoring = calculateScoring(child, 'textboxValue', companyData?.taxId)
                return {
                  ...child,
                  textboxValue: companyData?.taxId,
                  scoring: calculateScoring(child, 'textboxValue', companyData?.taxId),
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 35) {
                const scoring = calculateScoring(child, 'textboxValue', companyData?.taxOffice)
                return {
                  ...child,
                  textboxValue: companyData?.taxOffice,
                  scoring: calculateScoring(child, 'textboxValue', companyData?.taxOffice),
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 8) {
                const scoring = calculateScoring(child, 'textareaValue', companyData?.companyAdress)
                return {
                  ...child,
                  textareaValue: companyData?.companyAdress,
                  scoring,
                  outcome: (child.weight * scoring) / 100
                };
              }
              if (child.designId === 9) {
                const scoring = calculateScoring(child, 'bankListValue', bankAccount?.[0]?.accountNumber)
                return {
                  ...child,
                  bankListValue: bankAccount?.[0]?.accountNumber,
                  scoring,
                  outcome: (child.weight * scoring) / 100
                };
              }
              return child;
            })
          };
        });
        return updatedDueDiligence;
      });
      setIsFirst(false)
    }

  }, [companyData, tableData, bankAccount]);



  const [saveMutation] = usePostSupplierMutation();

  const reviseSupId = useSelector(state => state.otherSlice.reviseSupId)
  const reviseIsUpdate = useSelector(state => state.otherSlice.reviseIsUpdate)
  const [onSave, setOnSave] = useState(false)
  const handleSave = async () => {
    setOnSave(true)
    const updatedItemsNda = ndaData.map(item => {
      return { ...item, vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0 };
    });

    const updatedItemsCobc = cobcData.map(item => {
      return { ...item, vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0 };
    });

    const updatedBankAccount = bankAccount.map(item => {
      return { ...item, vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0 };
    });


    // fileLink-i olmayan attachment save-e getmemelidir
    const attachmentPayload = {
      companyInformation: companyData,
      bankAccounts: updatedBankAccount,
      dueDiligence: tableData,
    }
    if (!validateAttachmentsDeep(attachmentPayload)) {
      return
    }

    const saveData = await saveMutation({
      companyInformation: {
        ...companyData,
        vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0
      },
      nonDisclosureAgreement: updatedItemsNda,
      codeOfBuConduct: updatedItemsCobc,
      bankAccounts: updatedBankAccount,
      dueDiligence: tableData,
      isRevise: reviseSup
    });

    if (saveData?.data?.statusCode === 200) {
      showSuccessToast(`Succesfully saved`)
    } else if (saveData?.error?.status === 422) {
      showWarningToast(saveData?.error?.data?.errors)
    } else { showErrorToast('Error') }

  }

  const nextClicked = useSelector((state) => state.buttonSlice.nextClicked)

  const dispatch = useDispatch();
  useEffect(() => {
    if (nextClicked) {
      dispatch(offNextButton())
      dispatch(nextStep())
      dispatch(updateSupNextButtonLoading(true))
    }
  }, [dispatch, nextClicked])


  useEffect(() => {
    if (!isLoading) {
      dispatch(updateSupNextButtonLoading(false))
    }
  }, [isLoading, dispatch])

  const navigate = useNavigate()

  const [submitMutation] = useSubmitSupplierMutation();
  const [loadingSubmit, setLoadingSubmit] = useState(false)
  const handleSubmit = async () => {
    setOnSave(true)
    const updatedItemsNda = ndaData.map(item => {
      return { ...item, vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0 };
    });

    const updatedItemsCobc = cobcData.map(item => {
      return { ...item, vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0 };
    });

    const updatedBankAccount = bankAccount.map(item => {
      return { ...item, vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0 };
    });


    // fileLink-i olmayan attachment save-e getmemelidir
    const attachmentPayload = {
      companyInformation: companyData,
      bankAccounts: updatedBankAccount,
      dueDiligence: tableData,
    }
    if (!validateAttachmentsDeep(attachmentPayload)) {
      return
    }

    setLoadingSubmit(true)

    const saveData = await submitMutation({
      companyInformation: {
        ...companyData,
        vendorId: reviseSup && reviseIsUpdate ? reviseSupId : 0
      },
      nonDisclosureAgreement: updatedItemsNda,
      codeOfBuConduct: updatedItemsCobc,
      bankAccounts: updatedBankAccount,
      dueDiligence: tableData,
      isRevise: reviseSup,
      isSubmitted: true
    });

    if (saveData?.data?.statusCode === 200) {
      showSuccessToast(`Succesfully submitted Vendor Code: ${saveData?.data?.data?.companyInformation?.vendorCode}`)
      setLoadingSubmit(false)
      navigate(`/waiting`)
      window.location.reload();
    } else if (saveData?.error?.status === 422) {
      showWarningToast(saveData?.error?.data?.errors)
    } else {
      showErrorToast('Error')
      setLoadingSubmit(false)
    }

    dispatch(hideSubmitDialog());
    setLoadingSubmit(false)
  }

  return (
    <>
      {!isLoading ? (<>
        <Typography variant="h4" mb={3}>Due Diligence</Typography>

        {/* Header */}

        {/* <Grid container display="flex" justifyContent="space-between" mt={2} ml={-1}>
          <Grid item xs={4}></Grid>
          <Grid item xs={3}></Grid>
          <Grid item xs={3}>
            <Grid container textAlign='center' justifyContent='space-between' display='flex'>
              <Grid item xs={4}>
                <Chip label={`Question: ${tableData?.flatMap(x => x.childs)?.length}`} color="info" />
                <p>Score</p>
              </Grid>
              <Grid item xs={4}>
                <Chip label={`Answer: ${tableData?.flatMap(x => x.childs)?.filter(y => y.scoring > 0)?.length}`} color="info" />
                <p>Weight</p>
              </Grid>
              <Grid item xs={4}>
                <SupTotalScore value={totalScore} />
                <p>Outcome</p>
              </Grid>
            </Grid>
          </Grid>
        </Grid> */}

        {tableData?.map((list, i) => (
          <React.Fragment key={i}>
            <Box>
              <Typography textAlign="left" variant="h6">
                {list?.title}
              </Typography>
              <Divider />
            </Box>

            {list?.childs?.map((item, index) => (
              <Grid container display="flex" justifyContent="space-between" key={index}>
                <Grid item xs={12} sm={4} margin={1}>
                  {(item.designId === 43 && langCode === 'en') ? (
                    <>
                      <p style={{ margin: 0 }}>
                        {item.lineNo}. {item.question.split('for')[0]}
                        <Tooltip title={
                          <>
                            {"for" + item.question.substring(item.question.indexOf('for') + 3).split(';')[0] + ";"}
                            <br />
                            {item.question.substring(item.question.indexOf('for') + 3).split(';')[1]}
                          </>
                        }
                          placement="top-end">
                          <IconButton sx={{ p: 0 }}>
                            <Info style={{ color: 'blue' }} />
                          </IconButton>
                        </Tooltip>
                      </p>
                    </>
                  ) : (item.designId === 43 && langCode === 'az') ? (
                    <p style={{ margin: 0 }}>
                      {item.lineNo}. {item.question.split('for')[0]}
                      <Tooltip title={
                        <>
                          {"Azərbaycanda qeydiyyatdan keçmiş şirkətlər üçün Azərbaycan Respublikası İqtisadiyyat Nazirliyi yanında Dövlət Vergi Xidməti saytından ƏDV çıxarışını təqdim etmək;"}
                          <br />
                          {"Azərbaycandan kənarda qeydiyyatdan keçmiş şirkətlər üçün Ədliyyə Nazirliyindən qeydiyyat şəhadətnaməsi təqdim etmək;"}
                        </>
                      }
                        placement="top-end">
                        <IconButton sx={{ p: 0 }}>
                          <Info style={{ color: 'blue' }} />
                        </IconButton>
                      </Tooltip>
                    </p>
                  ) : (item.designId === 46 && langCode === 'en') ? (
                    <p style={{ margin: 0 }}>
                      {item.lineNo}. {item.question}
                      <Tooltip title={
                        <>
                          {"if you have not turnover details for any year set 0"}
                        </>
                      }
                        placement="top-end">
                        <IconButton sx={{ p: 0 }}>
                          <Info style={{ color: 'blue' }} />
                        </IconButton>
                      </Tooltip>
                    </p>
                  ) : (item.designId === 46 && langCode === 'az') ? (
                    <p style={{ margin: 0 }}>
                      {item.lineNo}. {item.question}
                      <Tooltip title={
                        <>
                          {"hər hansı bir il üçün dövriyyə təfərrüatlarınız yoxdursa, 0 təyin edin"}
                        </>
                      }
                        placement="top-end">
                        <IconButton sx={{ p: 0 }}>
                          <Info style={{ color: 'blue' }} />
                        </IconButton>
                      </Tooltip>
                    </p>
                  ) : (
                    <p style={{ margin: 0 }}>
                      {item.lineNo}. {item.question}
                    </p>
                  )}


                </Grid>

                <Grid item xs={12} sm={3} margin={1}>
                  <Box>
                    {
                      (item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime && <Box><SupText onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} value={item?.textboxValue} item={item} onSave={onSave} /> </Box>) ||
                      (item.hasRadioBox && !item.hasTextBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime && <Box><SupRadio onChange={(e) => handleChangeData(e, 'radioboxValue', index, i)} item={item} /></Box>) ||
                      (item.hasAttachment && !item.hasTextBox && !item.hasRadioBox && !item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime && <Box><SupAttachment onChange={(e) => handleChangeData(e, 'attachments', index, i)} item={item} onSave={onSave} /></Box>) ||
                      (item.hasDataGrid && !item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasSelectBox && !item.hasDateTime && <Box><SupDataGrid item={item} onSave={onSave} onChange={(data) => handleChangeData(data, 'gridDatas', index, i)} /></Box>) ||
                      (item.hasSelectBox && !item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasDateTime && <Box><SupSelect /></Box>) ||
                      (item.hasDateTime && !item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && <Box><SupDate item={item} onSave={onSave} onChange={(e) => handleChangeData(e, 'dateTimeValue', index, i)} /></Box>) ||
                      (item.hasTexArea && !item.hasDateTime && !item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && <Box><SupTextArea item={item} /></Box>) ||
                      (item.hasBankList && !item.hasTexArea && !item.hasDateTime && !item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && <Box>< SupSelect onChange={(e) => handleChangeData(e.target.value, 'bankListValue', index, i)} item={item} bankAccount={bankAccount} /></Box>) ||

                      (item.hasTextBox && item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupText onSave={onSave} onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} item={item} /></Box>
                          <Box><SupRadio onChange={(e) => handleChangeData(e, 'radioboxValue', index, i)} item={item} /></Box>
                        </Box>) ||

                      (item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupText onSave={onSave} onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} item={item} /></Box>
                          <Box><SupDate onChange={(e) => handleChangeData(e, 'dateTimeValue', index, i)} item={item} onSave={onSave} /></Box>
                        </Box>) ||
                      (item.hasTextBox && !item.hasRadioBox && !item.hasAttachment && item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupText onSave={onSave} onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} item={item} /></Box>
                          <Box><SupDataGrid item={item} onSave={onSave} onChange={(data) => handleChangeData(data, 'gridDatas', index, i)} /></Box>
                        </Box>) ||

                      (item.hasTextBox && item.hasRadioBox && !item.hasAttachment && item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupText onSave={onSave} onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} item={item} /></Box>
                          <Box><SupRadio onChange={(e) => handleChangeData(e, 'radioboxValue', index, i)} item={item} /></Box>
                          <Box><SupDataGrid item={item} onSave={onSave} onChange={(data) => handleChangeData(data, 'gridDatas', index, i)} /></Box>
                        </Box>) ||

                      (!item.hasTextBox && item.hasRadioBox && !item.hasAttachment && item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupRadio onChange={(e) => handleChangeData(e, 'radioboxValue', index, i)} item={item} /></Box>
                          <Box><SupDataGrid item={item} onSave={onSave} onChange={(data) => handleChangeData(data, 'gridDatas', index, i)} /></Box>
                        </Box>) ||

                      (item.hasTextBox && item.hasRadioBox && item.hasAttachment && !item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupText onSave={onSave} onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} item={item} /></Box>
                          <Box><SupRadio onChange={(e) => handleChangeData(e, 'radioboxValue', index, i)} item={item} /></Box>
                          <Box><SupAttachment onChange={(e) => handleChangeData(e, 'attachments', index, i)} item={item} onSave={onSave} /></Box>
                        </Box>) ||
                      (item.hasTextBox && !item.hasRadioBox && item.hasAttachment && item.hasDataGrid && !item.hasSelectBox && !item.hasDateTime &&
                        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, }}>
                          <Box><SupText onSave={onSave} onChange={(e) => handleChangeData(e.target.value, 'textboxValue', index, i)} item={item} /></Box>
                          <Box ><SupAttachment onChange={(e) => handleChangeData(e, 'attachments', index, i)} item={item} onSave={onSave} /></Box>
                          <Box><SupDataGrid item={item} onSave={onSave} onChange={(data) => handleChangeData(data, 'gridDatas', index, i)} /></Box>
                        </Box>)
                    }
                  </Box>
                </Grid>

                {/* <Grid item xs={12} sm={3} margin={1}>
                  <Grid container textAlign='center' justifyContent='space-between' display='flex'>
                    <Grid item xs={4}>
                      <Chip label={`${item.scoring?.toFixed(2)}`} size="small" />
                    </Grid>
                    <Grid item xs={4}>
                      <Chip label={`${item.weight?.toFixed(2)} %`} size="small" variant="outlined" />
                    </Grid>
                    <Grid item xs={4}>
                      <Chip label={`${item.outcome?.toFixed(2)}`} size="small" color="primary" />
                    </Grid>
                  </Grid>
                </Grid> */}
              </Grid >
            ))
            }
          </React.Fragment >
        ))
        }
        <SaveDialog handleSave={handleSave} text='Due Diligence' />
        <SubmitDialog handleSubmit={handleSubmit} text='Due Diligence' loadingSubmit={loadingSubmit} />
      </>) : <><SupLoading /></>
      }

    </>
  )
}
